export default "__VITE_ASSET__HI9CKNfV__"